var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStrataFees2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.016 1C17.903 1 17 3.686 17 7h2.016c.972 0 1.457 0 1.758-.335.3-.336.248-.778.144-1.661C20.64 2.67 19.894 1 19.016 1z",
    stroke: "#10c98f",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.054v10.592c0 1.511 0 2.267-.462 2.565-.755.486-1.922-.534-2.509-.904-.485-.306-.727-.458-.996-.467-.291-.01-.538.137-1.062.467l-1.911 1.205C9.545 20.837 9.287 21 9 21c-.287 0-.545-.163-1.06-.488l-1.91-1.205c-.486-.306-.728-.458-.997-.467-.291-.01-.538.137-1.062.467-.587.37-1.754 1.39-2.509.904C1 19.913 1 19.158 1 17.646V7.054c0-2.854 0-4.28.879-5.167C2.757 1 4.172 1 7 1h12M5 5h8M7 9H5",
    stroke: "#10c98f",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.875c-.828 0-1.5.588-1.5 1.313 0 .724.672 1.312 1.5 1.312s1.5.588 1.5 1.313c0 .724-.672 1.312-1.5 1.312m0-5.25c.653 0 1.209.365 1.415.875M11.5 9.875V9m0 6.125c-.653 0-1.209-.365-1.415-.875m1.415.875V16",
    stroke: "#10c98f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default SvgIconStrataFees2;